// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SurveyQuestionCategoryModel {
    static getAttributeTypeMap() {
        return SurveyQuestionCategoryModel.attributeTypeMap;
    }
}
SurveyQuestionCategoryModel.discriminator = undefined;
SurveyQuestionCategoryModel.additionalProperties = false;
SurveyQuestionCategoryModel.attributeTypeMap = [
    {
        "name": "questionCategoryId",
        "baseName": "questionCategoryId",
        "type": "number"
    },
    {
        "name": "questionCategoryTypeCode",
        "baseName": "questionCategoryTypeCode",
        "type": "string"
    },
    {
        "name": "questionCategoryTypeDescription",
        "baseName": "questionCategoryTypeDescription",
        "type": "string"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    },
    {
        "name": "questionCategoryCode",
        "baseName": "questionCategoryCode",
        "type": "string"
    },
    {
        "name": "questionCategoryTypeId",
        "baseName": "questionCategoryTypeId",
        "type": "number"
    },
    {
        "name": "userName",
        "baseName": "userName",
        "type": "string"
    },
];
//# sourceMappingURL=surveyQuestionCategoryModel.js.map